module.exports = __webpack_public_path__ + "static/media/storytelling-1@2x.072fb769.png";